import React from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import getReportList from "../../actions/getReportList";
import showLogin from "../../actions/showLogin";
import MainLayout from "../Layout/Layout";
import {Button, Card, Col, Empty, Row, Tag, Typography} from "antd";
import {
    AuditOutlined,
    FileSearchOutlined,
    IdcardOutlined,
    SafetyCertificateOutlined,
    TeamOutlined,
    MessageOutlined
} from "@ant-design/icons";

const reportVisuals = {
    operations: {
        title: 'Consumo de Operaciones',
        description: 'Consulta y exporta el consumo de operaciones por cliente en un periodo específico.',
        icon: <FileSearchOutlined/>
    },
    sms: {
        title: 'Consumo SMS y Llamadas',
        description: 'Revisa el uso de mensajes y llamadas para validaciones comerciales.',
        icon: <MessageOutlined/>
    },
    pkicertificates: {
        title: 'Estado de Certificados',
        description: 'Consulta métricas de certificados emitidos, vigentes, pendientes y revocados.',
        icon: <SafetyCertificateOutlined/>
    },
    pkiCertificates: {
        title: 'Estado de Certificados',
        description: 'Consulta métricas de certificados emitidos, vigentes, pendientes y revocados.',
        icon: <SafetyCertificateOutlined/>
    },
    users: {
        title: 'Usuarios Firmadores',
        description: 'Genera reportes de usuarios asociados a clientes firmadores.',
        icon: <TeamOutlined/>
    },
    auditReport: {
        title: 'Auditoría de Eventos',
        description: 'Consulta eventos, movimientos y acciones realizadas por usuarios.',
        icon: <AuditOutlined/>
    },
    andes: {
        title: 'Reporte Andes',
        description: 'Genera el reporte Andes para validaciones comerciales.',
        icon: <IdcardOutlined/>
    }
};

const normalizeText = (value) => (value || '').toLowerCase();

const getReportVisual = (report) => {
    const byLink = reportVisuals[report.link];
    if (byLink) {
        return byLink;
    }

    const name = normalizeText(report.name);

    if (name.includes('operaciones')) return reportVisuals.operations;
    if (name.includes('sms') || name.includes('llamadas')) return reportVisuals.sms;
    if (name.includes('pki') || name.includes('certificados')) return reportVisuals.pkicertificates;
    if (name.includes('usuarios')) return reportVisuals.users;
    if (name.includes('auditor')) return reportVisuals.auditReport;
    if (name.includes('andes')) return reportVisuals.andes;

    return {
        title: report.name,
        description: 'Consulta información disponible para procesos comerciales.',
        icon: <FileSearchOutlined/>
    };
};

const isLegacyReport = (report) => normalizeText(report.link).includes('filldata') || normalizeText(report.name).includes('filldata');

class ReportsList extends React.Component
{
    componentDidMount()
    {
        if(!this.props.login.tokenId || !this.props.login.profileObj)
            this.props.showLogin();
        if(this.props.reports.reportList.length===0)
            this.props.getReportList();
    }

    render()
    {
        return (
            <MainLayout title={'logo'} size={'medium'} variant="dashboard">
                <div className="reports-dashboard">
                    <div className="reports-dashboard-intro">
                        <Typography.Title level={2}>Seleccione el reporte que desea consultar</Typography.Title>
                        <Typography.Paragraph>
                            Elija una opción para revisar consumos, usuarios, certificados o eventos operativos.
                        </Typography.Paragraph>
                    </div>
                    {this.props.reports.reportList.length > 0 ?
                        <Row gutter={[22, 22]} className="reports-grid">
                            {this.props.reports.reportList.map(report => {
                                const visual = getReportVisual(report);
                                const legacy = isLegacyReport(report);

                                return (
                                    <Col xs={24} sm={12} lg={8} key={`${report.groupID || 'report'}-${report.link}`}>
                                        <Card className={legacy ? 'report-card report-card-legacy' : 'report-card'}>
                                            <div className="report-card-icon">{visual.icon}</div>
                                            <div className="report-card-content">
                                                <div className="report-card-title-row">
                                                    <Typography.Title level={3}>{visual.title}</Typography.Title>
                                                    {legacy ? <Tag>Legacy / Interno</Tag> : ''}
                                                </div>
                                                <Typography.Paragraph>{visual.description}</Typography.Paragraph>
                                                <Link to={"/" + report.link}>
                                                    <Button type="primary" className="commercial-primary-button">
                                                        Abrir reporte
                                                    </Button>
                                                </Link>
                                            </div>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row> :
                        <Empty description="No hay reportes disponibles para mostrar."/>
                    }
                </div>
        </MainLayout>);
    }
}
function mapStateToProps(state) {
    return {
        login: state.login,
        reports: state.reports
    }
}
export default connect(mapStateToProps, {showLogin,getReportList})(ReportsList);
